import { PaletteOptions } from "@mui/material";
import * as Colors from "./colors";

export const palette: PaletteOptions = {
    mode: 'dark',
    primary: {
      main: Colors.Blue,
      dark: Colors.DarkBlue,
      contrastText: Colors.White,
    },
    secondary: {
      main: Colors.Selected,
    },
    success: {
      main: Colors.Green,
    },
    error: {
      main: Colors.Red,
    },
    warning: {
      main: Colors.Yellow,
    },
    divider: Colors.BorderGray,
    background: {
      default: Colors.Black,
      paper: Colors.Surface,
    },
    text: {
      primary: Colors.White,
      secondary: Colors.LightGray,
      disabled: Colors.DisabledText,
    },
  }
